import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography
} from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import BasicInfoIcon from '@material-ui/icons/Info'
import ChangePasswordIcon from '@material-ui/icons/Lock'

import { getTranslate } from '../../localization'
import BasicInfo from '../BasicInfo'
import ChangePassword from '../ChangePassword'
import useStyles from './styles/SettingMenuMobile.styles'

const SettingMenuMobile = () => {
  const classes = useStyles()
  return (
    <div>
      <Accordion className={classes.accordion}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <div className={classes.accordionSummary}>
            <BasicInfoIcon />
            <Typography variant="h5" color="textPrimary">
              {getTranslate('Basic Info')}
            </Typography>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <BasicInfo />
        </AccordionDetails>
      </Accordion>
      <Accordion className={classes.accordion}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <div className={classes.accordionSummary}>
            <ChangePasswordIcon />
            <Typography variant="h5" color="textPrimary">
              {getTranslate('Change Password')}
            </Typography>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <ChangePassword />
        </AccordionDetails>
      </Accordion>
    </div>
  )
}
export default SettingMenuMobile
